module.exports = __webpack_public_path__ + "static/media/telegram.9a180ec6.svg";